import { render, staticRenderFns } from "./CreateRDIModal.vue?vue&type=template&id=54e0b0aa&scoped=true"
import script from "./CreateRDIModal.vue?vue&type=script&lang=js"
export * from "./CreateRDIModal.vue?vue&type=script&lang=js"
import style0 from "./CreateRDIModal.vue?vue&type=style&index=0&id=54e0b0aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e0b0aa",
  null
  
)

export default component.exports